<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-20 11:22:43
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-08 18:52:35
-->

<template>
  <div
    class="boxMian"
    v-if="configInfo"
    :style="{
      backgroundColor: configInfo.backgroundColour,
    }"
  >
    <div class="page-wrapper" :style="{ backgroundImage: `url('${imgHost}page/bg.png')` }">
      <img class="kv" :src="`${imgHost}page/payKv.png`"/>
      
      <div class="titleList">
        <img class="title"  v-for="(index) in 7" :key="index" :src="`${imgHost}page/title${index}.png`"/>
      </div>

      <img class="payBtn debounce" :src="`${imgHost}page/payBtn.png`" @click="handleCoupon"/>
      <img class="payText" :src="`${imgHost}page/payText.png`"/>
      <BaseBottom :configInfo="configInfo" />
      <ActBaseBtnHome :bColor="configInfo.buttonBackgroundColour" :textColor="configInfo.buttonTextColour"></ActBaseBtnHome>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},

  data() {
    return {
      configInfo:null,
      day: "00",
      hour: "00",
      minute: "00",
      second: "00",
    };
  },

  mounted() {
    this.configInfo = this.$configInfo;
    if (this.$configInfo.shareSwitch!= 1) {
      this.$wx.hideOptionMenu();
    }
    this.getCouponPrize()
  },
  methods: {
    async getCouponPrize() {
      let url = this.$apizt.action.getCouponPrize;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        this.couponList = data;
      }
    },
    async handleCoupon() {
      const item=this.couponList[0]
      let receiveKey = '';
      
      if (item.isReceive) {
        return this.$showToast("已经购买或锁定过当前优惠券了!", "提示");
      }
      if (item.winType == 5) {
        let url = this.$apizt.action.lockCoupon.api;
        const { data, result } = await this.$httpzt.requestRestFul(`${url}${item.code}`, {}, "post");
        if (result) {
          receiveKey = data;
        } else {
          return;
        }
      }
      this.$modal.form.alert({
        type: item.winType == 5 ? "key" : "code",
        prizeType: 2,
        code: item.code,
        prizeName: item.name,
        receiveKey: receiveKey,
        winType: item.winType,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.boxMian {
  width: 100%;
  min-height: 100vh;

  .page-wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom:120px;
    .kv{
      width:348px;
      margin:52px  auto 0;
    }
    .titleList{
      display: flex;
      justify-content: space-between;
      width:336px;
      flex-wrap: wrap;
      margin:7px  auto 0;
      .title{
        width:160px;
        height:122px;
        margin-bottom:8px;
      }
      .title:last-child{
        width:334px;
        height:85px;
        margin :auto;
      }
    }
   
    .tip1{
      width:135px;
      margin:3px auto 0;
    }
    
    .countDown {
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 8px;
      font-size: 20px;
      text-align: center;
      color:#fff;

      .time {
        height: 28px;
        border-radius: 4px;
        line-height: 28px;
        margin: 0 5px;
        padding: 0 7px;
        background-color: #FC534C;
      }
    }
    .payBtn{
      position: fixed;
      bottom:26px;
      width: 181px;
      left:97px;
    }
    .payText{
      position: fixed;
      bottom:18px;
      width: 89px;
      left:143px;
    }
  }

}
</style>
